export const TIMEZONES = {
    "US/Canada": [
        { label: "Pacific Time - US & Canada", value: "America/Los_Angeles" },
        { label: "Mountain Time - US & Canada", value: "America/Denver" },
        { label: "Central Time - US & Canada", value: "America/Chicago" },
        { label: "Eastern Time - US & Canada", value: "America/New_York" },
        { label: "Hawaii-Aleutian Time", value: "Pacific/Honolulu" },
        { label: "Alaska Time", value: "America/Anchorage" }
    ],
    "America": [
        { label: "Sao Paulo", value: "America/Sao_Paulo" },
        { label: "Buenos Aires", value: "America/Argentina/Buenos_Aires" },
        { label: "Mexico City", value: "America/Mexico_City" },
        { label: "Bogota", value: "America/Bogota" },
        { label: "Lima", value: "America/Lima" }
    ],
    "Europe": [
        { label: "London", value: "Europe/London" },
        { label: "Paris", value: "Europe/Paris" },
        { label: "Berlin", value: "Europe/Berlin" },
        { label: "Rome", value: "Europe/Rome" },
        { label: "Madrid", value: "Europe/Madrid" },
        { label: "Amsterdam", value: "Europe/Amsterdam" },
        { label: "Brussels", value: "Europe/Brussels" },
        { label: "Moscow", value: "Europe/Moscow" }
    ],
    "Asia": [
        { label: "India Standard Time", value: "Asia/Kolkata" },
        { label: "Tokyo", value: "Asia/Tokyo" },
        { label: "Singapore", value: "Asia/Singapore" },
        { label: "Hong Kong", value: "Asia/Hong_Kong" },
        { label: "Dubai", value: "Asia/Dubai" },
        { label: "Bangkok", value: "Asia/Bangkok" },
        { label: "Seoul", value: "Asia/Seoul" },
        { label: "Shanghai", value: "Asia/Shanghai" }
    ],
    "Australia": [
        { label: "Sydney", value: "Australia/Sydney" },
        { label: "Melbourne", value: "Australia/Melbourne" },
        { label: "Brisbane", value: "Australia/Brisbane" },
        { label: "Perth", value: "Australia/Perth" },
        { label: "Adelaide", value: "Australia/Adelaide" }
    ],
    "Pacific": [
        { label: "Auckland", value: "Pacific/Auckland" },
        { label: "Fiji", value: "Pacific/Fiji" }
    ],
    "Africa": [
        { label: "Cairo", value: "Africa/Cairo" },
        { label: "Johannesburg", value: "Africa/Johannesburg" },
        { label: "Lagos", value: "Africa/Lagos" },
        { label: "Nairobi", value: "Africa/Nairobi" }
    ],
    "Atlantic": [
        { label: "Azores", value: "Atlantic/Azores" },
        { label: "Cape Verde", value: "Atlantic/Cape_Verde" }
    ],
    "UTC": [
        { label: "Coordinated Universal Time", value: "UTC" }
    ]
};
